import React from 'react';
import styled from 'styled-components';

const PStyle = styled.div`
  max-width: 500px;
  margin: 0 auto;
  font-size: 1.8rem;
  line-height: 1.3em;
  @media only screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

export default function PText({ children }) {
  return (
    <PStyle className="para">
      <p
        data-aos="fade"
        data-aos-easing="ease-in"
        data-aos-delay="100"
        data-aos-offset="0"
      >
        {children}
      </p>
    </PStyle>
  );
}
